import React, { Component, Fragment } from "react";
import Usuarios from "../../../Components/Admin/Usuarios";

export default class PageAdminUsuarios extends Component {
    render() {
        return (
            <Fragment>
                <Usuarios />
            </Fragment>
        );
    }
}
